export default __webpack_public_path__ + "static/media/project-mobile.40ae3a11.svg";